import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type {
  AdConfigData,
  BaseConnectionData,
} from './EnterpriseConnectionSchema';
import {
  ClientCredentialsFields,
  DomainField,
  LoginExperienceSection,
} from './SharedSsoFormFields';

interface Props {
  isDisabled?: boolean;
}

const AdConfigurationForm: FC<Props> = ({ isDisabled = false }) => {
  const { control } = useFormContext<AdConfigData>();
  const baseControl = control as unknown as Control<BaseConnectionData>;
  const { t } = useTranslation('common', { keyPrefix: 'sso' });

  return (
    <>
      <DomainField
        control={baseControl}
        isDisabled={isDisabled}
        label={t('domain.ad.label')}
        description={t('domain.ad.description')}
        placeholder={t('domain.ad.placeholder')}
      />

      <ClientCredentialsFields
        control={baseControl}
        isDisabled={isDisabled}
        providerLabel={'LDAP'}
      />

      <LoginExperienceSection control={baseControl} isDisabled={isDisabled} />
    </>
  );
};

export default AdConfigurationForm;
